export default "__VITE_ASSET__DnF5PAiL__"